import React, { useEffect, useRef } from "react";
import "../components/css/style.css";

export default function AboutSection() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const elements = sectionRef.current.querySelectorAll(".reveal");

        const observer = new IntersectionObserver(
            (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                entry.target.classList.add("active");
                }
            });
            },
            { threshold: 0.15 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }, []);

    return (
        <section className="agency-section" ref={sectionRef}>
        <div className="agency-visual reveal">
            <div className="circle c1 float">Website Development
            <span>Custom • Fast • Conversion Focused</span>
            </div>

            <div className="circle c2 float delay1">Mobile App Design/Development
            <span>Android & iOS Apps</span>
            </div>

            <div className="circle c3 float delay2">Complete Brand Identity
            <span>Logo • Visuals • Brand Systems</span>
            </div>

            <div className="circle c4 float delay3">Digital Marketing
            <span>SEO • Content • Social Presence</span>
            </div>

            <div className="circle c5 float delay4">Performance Marketing
            <span>Meta & Google Ads • ROI Growth</span>
            </div>
        </div>

        <div className="agency-content reveal">
            <span className="badge">About Our Agency</span>

            <h1>
            Transforming Vision Into Powerful Digital Experiences
            </h1>

            <p>
            We are a full-service digital agency helping brands grow through
            strategic design, cutting-edge development, and performance-driven
            marketing.
            </p>

            <p>
            From brand identity to high-converting platforms and ROI-focused
            advertising campaigns, we create digital ecosystems.
            </p>

            <button className="agency-cta" onClick={() => window.location.href = "/services"}>Explore Our Services</button>
        </div>
        </section>
    );
}
